<template lang="slm">
  loader v-if="!article"
  article.Article v-else=""
    header.container
      .columns.is-multiline
        .column.is-8.is-offset-2.is-7-widescreen
          .content
            h1 {{article.title}}
            p.lead-in style="margin-bottom: 44px;" {{article.lead}}
        .column.is-10.is-offset-1 v-if="article.headerImage"
          image-source :source="article.headerImage.asset.url" :ratio=1.78 :alt="article.headerImage.caption" :widths="mediumWidths"

    .container v-if="article.blocks"
      .columns.is-multiline
        block-render :blocks="article.blocks.content" :textWrapClasses="'column is-8 is-7-widescreen is-offset-2'"

    section(style="margin-bottom: 0;" v-if="article.factbox")
      .container v-if="article.factbox.content"
        .columns
          .column.is-9.is-offset-1
            .InfoBox
              .content
                block-render :blocks="article.factbox.content"

    section
      .container
        .columns
          .column.is-7.is-offset-2
            .content
              .is-clearfix
                a.is-pulled-right.Button.is-outline.is-font-sans.Sharebutton :href="shareUrl"
                  |Del på Facebook

    section v-if="relatedIssues"
      .container
        .columns
          .column.is-7.is-offset-2
            .content
              h3 Les mer om lignende saker
              div.IssueList-item v-for="relatedIssue in relatedIssues"
                  a :href="getSlug(relatedIssue)" {{relatedIssue.title}}

</template>

<script>
import BlockRender from '@/components/BlockRender'
import ImageSource from '@/components/ImageSource'
import sanityQuery from '@/sanityQuery'
import Loader from '@/components/Loader'

export default {
  name: 'issue-article',
  props: ['article'],
  components: {
    'blockrender': BlockRender,
    ImageSource,
    Loader
  },
  data () {
    return {
      mediumWidths: [700, 1500, 2000],
      relatedIssues: null,
      classes: 'column'
    }
  },
  created () {
    var query = `*[_type == "issue" && category == "${this.article.category}" && slug.current != "${this.article.slug.current}"]{title, slug, "redirect": redirect->{title, slug}}`
    sanityQuery(query).then((result) => {
      this.relatedIssues = result
    })
  },
  computed: {
    shareUrl: function () {
      return `https://www.facebook.com/dialog/share?app_id=520751354930010&display=popup&href=https://rødungdom.no${this.$route.path}&redirect_uri=https://rødungdom.no${this.$route.path}`
    }
  },
  methods: {
    getSlug (issue) {
      if (issue.redirect) {
        return issue.redirect.slug.current
      } else {
        return issue.slug.current
      }
    }
  },
  metaInfo () {
    return {
      title: this.article.title + ' \u2014 Rød Ungdom', // set a title
      htmlAttrs: {
        lang: 'no',
        amp: undefined // "amp" has no value
      },
      meta: [
        {name: 'title', content: this.article.title + ' \u2014 Rød Ungdom'},
        {name: 'description', content: this.article.lead},
        {name: 'twitter:title', content: this.article.title + ' \u2014 Rød Ungdom'},
        {name: 'twitter:description', content: this.article.lead},
        {name: 'twitter:image', content: `${this.article.headerImage ? this.article.headerImage.asset.url + '?w=1200&h=630&fit=crop' : 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png'}`},
        {property: 'og:title', content: this.article.title + ' \u2014 Rød Ungdom'},
        {property: 'og:description', content: this.article.lead},
        {property: 'og:image', content: `${this.article.headerImage ? this.article.headerImage.asset.url + '?w=1200&h=630&fit=crop' : 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png'}`},
        {property: 'og:url', content: 'http://xn--rdungdom-54a.no' + this.$route.path}
      ]
    }
  }
}
</script>

<style lang="sass">
@import '../assets/stylesheets/_variables.sass'

.Sharebutton
  text-decoration: none !important
  font-size: $size-5 !important
</style>



// WEBPACK FOOTER //
// src/components/IssueArticle.vue